import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption } from '@/design-system/components/typography';
import { ScrollView, SxProp, View } from 'dripsy';
import _ from 'lodash';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { LayoutContext } from 'contexts/LayoutContext';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { UpdateCardKycStackParamList } from './type';
import moment from 'moment-timezone';

export interface CardKycInfoPlacedProps {
  onClose: () => void;
  data: any;
  onLayout: (event: any) => void;
  returnData?: any;
  refresh?: () => void;
}

export const CardKycInfoPlacedWebScreen: React.FC<CardKycInfoPlacedProps> = (props) => {
  const { onLayout } = props;
  const { t } = useTranslation('card-account');
  const layout = useContext(LayoutContext);
  const {
    topHeader,
    body,
    btn,
    textHeaderTitle,
  } = sxStyles;

  const navigation = useNavigation<NativeStackNavigationProp<UpdateCardKycStackParamList>>();

  return (
    <View
      sx={{
        height: layout.isMobile ? '100%' : 'auto',
        width: layout.dimensions.width,
        maxWidth: layout.isMobile ? layout.dimensions.width : Math.min(500, layout.dimensions.width),
        maxHeight: layout.dimensions.height,
        backgroundColor: '$backgroundPrimary'
      }}
      onLayout={(event) => {
        onLayout(event);
      }}>
      <View sx={topHeader}>
        <Icon name="checkCircleBlue" height={90} width={90} />
        <H6 bold sx={textHeaderTitle}>
          {t('card-account::credit-card-new-account.update-kyc-info-page.title--update-success-placed')}
        </H6>
      </View>
      <ScrollView sx={{ flex: 1, backgroundColor: 'transparent' }} nestedScrollEnabled>
        <View sx={body}>
          <UniButton
            sx={btn}
            labelSx={{ color: '$balck' }}
            label={t('card-account-management::general.button--close')}
            onPress={() => {
              navigation.getParent()?.goBack();
            }}
          />
        </View>
      </ScrollView>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault',
    mt: '$10'
  },
  body: {
    minHeight: 100,
    minWidth: 500,
    px: 28,
    py: 28,
    gap: '$5'
  },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  btn: {
    width: '100%',
    height: 44
  },
  textHeaderTitle: {
    mb: '$2'
  },
  textHeaderSubTitle: {
    color: '$textPrimary'
  }
};